module.exports = __webpack_public_path__ + "static/media/livingSpirit.2f1ec306.png";


//////////////////
// WEBPACK FOOTER
// ./src/lib/monsterImages/livingSpirit.png
// module id = 126
// module chunks = 0